<template src="./404PageComponent.html"></template>
<script>
import ButtonBackComponent from "@/components/buttons/button-back/ButtonBackComponent.vue";

export default {
  name: '404PageComponent',
  components: {
    ButtonBackComponent
  },
  setup() {

    return {
    }
  },
}
</script>
<style lang="scss">
</style>
